/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useContext } from 'react';
import { AppContext } from '../layout/Main';
// @ts-ignore
import { Helmet } from 'react-helmet';
import { OrganizationRecord } from '@/admin/Organizations/common/types';

const CustomFavIcon = () => {
  const context = useContext(AppContext);
  const { organization } = context as { organization: OrganizationRecord };

  return (
    <>
      {organization?.favicon_url && (
        <Helmet>
          <link rel="icon" type="image/x-icon" href={organization?.favicon_url} />
        </Helmet>
      )}
    </>
  );
};

export default CustomFavIcon;
